import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './views/Dashboard.vue';
import Forbidden from './views/Forbidden.vue';
import NotFound from './views/NotFound.vue';

import $ from 'jquery';
import { ka } from './utils/konalytics';
import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true,
});

var router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/:lang?/',
      component: {
        render: h => h('router-view'),
      },
      children: [
        {
          path: '/',
          name: 'Dashboard',

          component: Dashboard,
          meta: { layout: 'default' },
        },
        {
          path: '/nopermission/',
          name: '403',
          meta: {
            displayName: '403',
          },
          component: Forbidden,
        },
        {
          path: '*',
          name: '404',
          meta: {
            displayName: '404',
          },
          component: NotFound,
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  next();
  ka('pageview', {
    description: to.name,
    pagePath: to.fullPath,
  });
});

export default router;
